/**
 * Servicios que envian el header numberOfDecimalsBE (CI-21977).
 * Para agregar/quitar un servicio de la integracion, edita SOLO esta lista (match por url.includes).
 */
export const DECIMALS_SERVICES: string[] = [
  // Irops
  '/sc/flight/search/v2',
  '/sc/products',
  // Ancillaries
  '/ac/seatmap/v2',
  '/ac/seat/v3',
  '/ac/ancillaries/v2',
  '/ac/reassign/seat',
  // Pago (URLs reales de ESTE kiosko)
  '/pc/emit-ticket-ancillary',
  'payment-revenue-dc',
  // '/pc/pectab-receipt',    // recibo: descomentar si el BE requiere el param tambien aqui
];
export const DECIMALS_HEADER = 'numberOfDecimalsBE';
export const DECIMALS_DEFAULT = 2;
